// 新聞頁 - 分類 top 新聞 ( 5則熱門新聞 )
// 快訊頁 - 今日 top 新聞 ( 5則熱門新聞 )
"use client";
import { useState, useEffect } from "react";
import newsClient from "@/common/apiClient/newsClient";
import { NEWS_CATEGORY_MAP } from "@/common/constant";
import { useTranslation } from "react-i18next";

import TopNewsComponent from "../basic/TopNewsComponent"; // top 新聞 元件
import TopNewsSkelton from "../../components/skelton/TopNewsSkelton";

const AsideTopNews = ({ category, locale, isShowTodayText }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false); // 載入中
  // 熱門新聞
  const [topNews, setTopNews] = useState({
    [NEWS_CATEGORY_MAP["HOT"]]: [],
    [NEWS_CATEGORY_MAP["DEFI"]]: [],
    [NEWS_CATEGORY_MAP["INTL"]]: [],
    [NEWS_CATEGORY_MAP["VIEW"]]: [],
    [NEWS_CATEGORY_MAP["SOCIAL"]]: [],
    [NEWS_CATEGORY_MAP["SUPERVISE"]]: [],
    [NEWS_CATEGORY_MAP["BUSINESS"]]: [],
    [NEWS_CATEGORY_MAP["TECH"]]: [],
    [NEWS_CATEGORY_MAP["AI"]]: [],
    [NEWS_CATEGORY_MAP["AIRDROP"]]: [],
    [NEWS_CATEGORY_MAP["GAMEFI"]]: [],
    [NEWS_CATEGORY_MAP["NFT"]]: [],
    [NEWS_CATEGORY_MAP["NEWBIE"]]: [],
  });

  // 取得各分類熱門新聞
  const getPopularNewsByCategory = async () => {
    try {
      setLoading(true);
      const result = await newsClient.getPopularNewsByCategoryCode(
        locale,
        category,
        5
      );

      if (result) {
        setTopNews((prev) => ({ ...prev, [category]: result }));

        setTimeout(() => {
          setLoading(false);
        }, 300);
      }
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  };

  useEffect(() => {
    if (topNews?.[category]?.length === 0) getPopularNewsByCategory();
  }, [category]);

  return (
    <div className="sticky top-[75px] mt-[22px]">
      <p className="text-bd2b text-black my-[12px] h-[25px]">
        {isShowTodayText ? "TODAY" : t(category?.toUpperCase())} TOP NEWS
      </p>
      <div>
        {loading
          ? new Array(5)
              .fill(0)
              .map((_, i) => <TopNewsSkelton key={i + "aside-top" + i} />)
          : topNews?.[category]?.map((news, i) => (
              <TopNewsComponent
                key={i + category + news?.id + "top-news"}
                news={news}
                i={i}
              />
            ))}
      </div>
    </div>
  );
};

export default AsideTopNews;
